import axios from 'axios';
const prefix = 'Resources';
const Resource = a => `${prefix}/${a}`;
export default {
    roles(params = {}, config = {}) {
    const url = Resource('Roles');
    return params === true ? url : axios.get(url, {...config, params: {...params, itemsPerPage: -1}});
  }
};